/*
  Colour swatch swap for product cards.

  Fetches ?view=card-item of the clicked colour and replaces the inside of
  .product-card-wrapper. No slider code here: assets/card-slider.js picks the
  new gallery up on its own (event delegation + MutationObserver).

  Replaces the old $('body').on('click', '.custom-color-meta_ar', ...) handler.
  Delete the old one, otherwise a click swaps twice.
*/
(function () {
  if (window.__cardColorSwapReady) return;
  window.__cardColorSwapReady = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.custom-color-meta_ar');
    if (!link) return;
    event.preventDefault();

    var wrapper = link.closest('.product-card-wrapper');
    var url = link.getAttribute('data-card-url');
    if (!wrapper || !url) return;

    // Swatch of the product that is already shown
    var input = link.querySelector('input');
    if (input && input.checked) return;

    // Last click wins when swatches are clicked in quick succession
    var token = (wrapper.__swapToken = (wrapper.__swapToken || 0) + 1);

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (token !== wrapper.__swapToken) return;

        // DOMParser does not execute scripts in the response
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.product-card-wrapper');
        if (!card) throw new Error('.product-card-wrapper missing in ' + url);

        wrapper.innerHTML = card.innerHTML;

        // Optional, the observer already covers this
        if (window.cardSliderRefresh) window.cardSliderRefresh(wrapper);
      })
      .catch(function (err) {
        console.error('Colour swap failed:', err);
      });
  });
})();
